var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import { GridColumnMenu } from "./GridColumnMenu";
import { emptyColumnsContentRenderer } from './emptyColumnsContentRenderer';
var SHOWN_STATE_COLUMN_ID = '__internalShownStateColumn__';
var SHOWN_STATE_COLUMN_WIDTH = 18;
var SHOWN_STATE_COLUMN_ORDER = 99999999999;
export function gridColumnShownStatePlugin(config) {
    return function (_a) {
        var getColumns = _a.getColumns;
        var bodyAddons = [];
        bodyAddons.push({
            id: 'notHaveColumns',
            render: function () {
                if (getColumns().filter(function (i) { return !i.isService; }).length) {
                    return React.createElement(React.Fragment, { key: 'notHaveColumns' });
                }
                return emptyColumnsContentRenderer();
            }
        });
        return {
            bodyAddons: bodyAddons,
            containerAddons: [
                {
                    id: '',
                    order: 0,
                    render: function () {
                        return React.createElement(GridColumnMenu, {
                            items: config.menu
                        });
                    }
                }
            ],
            processColumns: function (columns) {
                var menuIDs = config.menu.map(function (i) { return i.id; });
                var shownIDs = config.menu.filter(function (i) { return i.value; }).map(function (i) { return i.id; });
                columns = __spreadArrays(columns).filter(function (i) {
                    return !menuIDs.includes(i.id) || shownIDs.includes(i.id);
                });
                return __spreadArrays(columns, [
                    {
                        id: SHOWN_STATE_COLUMN_ID,
                        width: SHOWN_STATE_COLUMN_WIDTH,
                        minWidth: SHOWN_STATE_COLUMN_WIDTH,
                        maxWidth: SHOWN_STATE_COLUMN_WIDTH,
                        order: SHOWN_STATE_COLUMN_ORDER,
                        isService: true,
                        header: function () { return React.createElement(React.Fragment); },
                        cell: function () { return React.createElement(React.Fragment); }
                    }
                ]);
            }
        };
    };
}
//# sourceMappingURL=gridColumnShownStatePlugin.js.map